var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.85 23l-9.875-9.875l7.55-7.55l3.65 3.65l.7-.7l-5.35-5.35L1.7 10l.975.975L1.25 12.4l-2.35-2.35L8.575.375l3.1 3.1l3.1-3.1l9.85 9.85zm.025-2.8l9.925-9.975l-7.05-7.05l-1.675 1.675l3.65 3.65l-3.55 3.55l-3.65-3.65L4.8 13.125l.725.725l3.725-3.725l1.4 1.4l-3.725 3.725l.7.7l3.725-3.725l1.425 1.425l-3.725 3.725l.7.7l3.725-3.725l1.4 1.4l-3.725 3.725zm-2.9-12.825"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferral);
export default __webpack_public_path__ + "static/media/referral.531bdc3bd69cc3349ce5ddf5815cb0fc.svg";
export { ForwardRef as ReactComponent };